import { keweenawPhotos } from "../../data/careers";
import { cx } from "../../lib/cx";
import { photoProps } from "../../lib/links";

// Bento layout for the six Keweenaw photos: the aerial leads at 2×2, the
// sunset and the two closing shots run wide. Two columns on phones.
const tiles = [
  "col-span-2 aspect-[16/10] md:row-span-2 md:aspect-auto",
  "aspect-square md:aspect-auto",
  "aspect-square md:aspect-auto",
  "col-span-2 aspect-[16/9] md:aspect-auto",
  "aspect-[4/3] md:col-span-2 md:aspect-auto",
  "aspect-[4/3] md:col-span-2 md:aspect-auto",
];
const sizes = [
  "(max-width: 768px) 100vw, 560px",
  "(max-width: 768px) 50vw, 280px",
  "(max-width: 768px) 50vw, 280px",
  "(max-width: 768px) 100vw, 560px",
  "(max-width: 768px) 50vw, 560px",
  "(max-width: 768px) 50vw, 560px",
];

/** The Keweenaw, in photos, with a small caption on each. */
export default function KeweenawMosaic({ className }) {
  return (
    <ul
      className={cx(
        "grid grid-cols-2 gap-3 md:auto-rows-[200px] md:grid-cols-4 md:gap-4 lg:auto-rows-[220px]",
        className,
      )}
    >
      {keweenawPhotos.map(({ file, alt, caption }, i) => (
        <li
          key={file}
          className={cx(
            "group relative overflow-hidden rounded-brand bg-ink-2 ring-1 ring-white/10",
            tiles[i % tiles.length],
          )}
        >
          <img
            {...photoProps(file, sizes[i % sizes.length])}
            alt={alt}
            loading="lazy"
            className="absolute inset-0 size-full object-cover transition-transform duration-700 group-hover:scale-[1.04] motion-reduce:group-hover:scale-100"
          />
          <span
            aria-hidden="true"
            className="pointer-events-none absolute inset-x-0 bottom-0 bg-linear-to-t from-ink/80 to-transparent px-3.5 pt-10 pb-3"
          >
            <span className="tag block text-[11px] leading-snug text-white">
              {caption}
            </span>
          </span>
        </li>
      ))}
    </ul>
  );
}
